import React, { Component } from 'react'
import { withRouter }       from 'react-router-dom'

import Meta    from './meta'
import Preview from './preview'

import './css/modal.css'

class Modal extends Component {

  state = {}

  componentDidMount() {
    this.steps = 0
    this.load(this.props)
  }

  componentWillReceiveProps(props) {
    this.steps += 1
    this.load(props)
  }

  load(props) {
    this.setState({attachment: props.attachment})
  }

  close() {
    if (!this.steps) {
      this.props.history.replace((this.state.attachment.item && this.state.attachment.item.url) || this.state.attachment.section.url)
    } else {
      this.props.history.go(-this.steps-1)
    }
  }

  render() {
    return !this.state.attachment ? '' : (
      <div className="modal" onClick={(e) => e.target.className === 'modal' && this.close()}>
        <Meta data={this.props.data} item={this.state.attachment} />
        <div className="modal-top">
          <div className="modal-close" onClick={this.close.bind(this)} />
        </div>
        <Preview data={this.props.data} image={this.state.attachment} />
      </div>
    )
  }

}

Modal = withRouter(Modal)

export default Modal



// WEBPACK FOOTER //
// ./src/components/modal.js